import React from 'react';

const LanguageContext = React.createContext({
  language: 'en',
  setLanguage: () => {},
  t: key => key
});

export { LanguageContext };
